import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Drawer from '@material-ui/core/Drawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Divider from '@material-ui/core/Divider';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import MeetingRoom from '@material-ui/icons/MeetingRoom';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ArtTrack from '@material-ui/icons/ArtTrack';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Email from '@material-ui/icons/Email';
import PersonAdd from '@material-ui/icons/PersonAdd';

const drawerWidth = 240;

const styles = theme => ({
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});

class Sidebar extends React.Component {
  state = {
    userOpen: false
  }

  handleClick = () => {
    this.setState(state => ({ userOpen: !state.userOpen }));
  };

  renderChildLink = (links) => {
    const { dispatch, classes } = this.props;
    return links.map((l, idx) => {
      return (
      <ListItem key={idx} button className={classes.nested}>
        <ListItemIcon>
          {l.icon && l.icon}
        </ListItemIcon>
        <ListItemText inset primary={l.name}  onClick={() => dispatch(push(l.link))}/>
      </ListItem>);
    })
  };

  getSidebarItems = (sidebarMenu) => {
    const { dispatch } = this.props;
    const { userOpen } = this.state;

    return sidebarMenu.map((s, idx) => {
      return (
        <React.Fragment key={idx}>
          <ListItem button onClick={() => s.children ? s.openhandler() : {}}>
            <ListItemIcon>
              {s.icon}
            </ListItemIcon>
            <ListItemText primary={s.name} onClick={() => s.link && dispatch(push(s.link))} />
            { s.children && (userOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
          {
            s.children &&
            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {this.renderChildLink(s.children)}
              </List>
            </Collapse>
          }

        </React.Fragment>
      )
    });
  }

  render() {
    const { classes, open, handleDrawerClose } = this.props;

    const sidebarMenu = [
      {
        name: 'Dashboard',
        icon: <DashboardIcon />,
        link: '/dashboard'
      },
      {
        name: 'Users',
        icon: <PeopleIcon />,
        link: '',
        openhandler: () => this.handleClick(),
        children: [
          {
            name: 'Vacancy Providers',
            icon: '',
            link: '/users/2'
          },
          {
            name: 'Roomers',
            icon: '',
            link: '/users/1'
          },
        ]
      },
      {
        name: 'Social Posts',
        icon: <ArtTrack />,
        link: '/posts'
      },
      {
        name: 'Vacancy Posts',
        icon: <MeetingRoom />,
        link: '/property'
      },
      {
        name: 'Roomer Posts',
        icon: <PersonAdd />,
        link: '/roomer-post'
      },
      {
        name: 'Endrosments',
        icon: <ThumbUp />,
        link: '/endrosments'
      },
      {
        name: 'Broadcast',
        icon: <Email />,
        link: '/broadcast'
      }
    ];

    return (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{this.getSidebarItems(sidebarMenu)}</List>
        <Divider />
      </Drawer>
    )
  }
}

export default connect()(withStyles(styles)(Sidebar));